/* eslint-disable no-restricted-globals */


import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, Row, Col, Alert, Input } from "reactstrap";
import useToken from "../../helpers/useToken"
import TMHLoader from "../TMHLoader/TMHLoader"
import NotificationUserTable from "./NotificationUserTable"
import Switch from "react-switch";

export default function SpinsCategory({ notify }) {
    const { token } = useToken()

    const [isLoading, setIsLoading] = useState(false)
    const [spinsCategory, setSpinsCategory] = useState();
    const [totalQualifyingUsers, setTotalQualifyingUsers] = useState({});
    const [currentNotificationConfig, setCurrentNotificationConfig] = useState(null);
    const [isOpenNotificationUserTable, setIsOpenNotificationUserTable] = useState(false);
    const myRef = React.createRef()

    useEffect(() => {
        const initData = () => {
            console.log('SpinsCategory: update data')
            setIsLoading(true)
            const myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };

            fetch(process.env.REACT_APP_BASE_URL + "notification/config/spins", requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        const json = result.json;
                        if (result.ok) {
                            setSpinsCategory(json)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [token])

    const handleSubmit = () => {
        console.log('SpinsCategory: submit data')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(spinsCategory)
        }

        fetch(process.env.REACT_APP_BASE_URL + "notification/config/spins", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    if (result.ok) {
                        notify('tl', 'Update Spins Notification success!', 'success')
                        setSpinsCategory(json)
                        setIsLoading(false)
                    }
                    else {
                        notify('tl', 'Update Spins Notification failed!\n' + result.json.message, 'danger')
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            )
    }

    const sendTestToMobile = (_notificationConfig) => {
        console.log('SpinsCategory: sendTestToMobile')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(_notificationConfig)
        }

        fetch(process.env.REACT_APP_BASE_URL + "notification/push_test", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    if (result.ok) {
                        notify('tl', 'Send Notification success!\n' + result.json.message, 'success')
                        setIsLoading(false)
                    }
                    else {
                        notify('tl', 'Send Notification failed!\n' + result.json.message, 'danger')
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            )
    }

    const handleRefreshTotalQualifyingUsers = (_notificationConfig) => {
        console.log('SpinsCategory: handleRefreshTotalQualifyingUsers')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(_notificationConfig)
        }

        fetch(process.env.REACT_APP_BASE_URL + "notification/qualifying_users", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    if (result.ok) {
                        notify('tl', 'Refresh Qualifying Users for `' + _notificationConfig.description + '` success!\nTotal: ' + result.json.page_dto.total, 'success')
                        var _totalQualifyingUsers = { ...totalQualifyingUsers }
                        _totalQualifyingUsers[_notificationConfig.description] = {
                            'total': result.json.page_dto.total,
                            'data': result.json.data
                        }
                        setTotalQualifyingUsers(_totalQualifyingUsers)
                        setIsLoading(false)
                    }
                    else {
                        notify('tl', 'Refresh Qualifying Users failed!\n' + result.json.message, 'danger')
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            )
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const handleShowTotalQualifyingUsers = (_notificationConfig) => {
        scrollToTop()
        handleSubmit()
        console.log('SpinsCategory: handleShowTotalQualifyingUsers')
        handleRefreshTotalQualifyingUsers(_notificationConfig)
        setIsOpenNotificationUserTable(true)
        setCurrentNotificationConfig(_notificationConfig)
    }

    const handlePushNotificationToTotalQualifyingUsers = (_notificationConfig) => {
        // eslint-disable-next-line no-restricted-globals
        if (totalQualifyingUsers[_notificationConfig.description]) {
            if (!confirm("Are you sure you want to send this message to " + totalQualifyingUsers[_notificationConfig.description].total + " users?")) { return }
        }
        else {
            if (!confirm("Are you sure you want to send this message to users?")) { return }
        }

        handleSubmit()
        console.log('SpinsCategory: handlePushNotificationToTotalQualifyingUsers')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(_notificationConfig)
        }

        fetch(process.env.REACT_APP_BASE_URL + "notification/push_to_qualifying_users", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    if (result.ok) {
                        notify('tl', 'Push Notification to Qualifying Users success!\n' + result.json.message, 'success')
                        setIsLoading(false)
                    }
                    else {
                        notify('tl', 'Push Notification to Qualifying Users failed!\n' + result.json.message, 'danger')
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            )
    }


    return (
        <TMHLoader active={isLoading}>
            {isOpenNotificationUserTable && <NotificationUserTable ref={myRef} notificationConfig={currentNotificationConfig} />}

            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h2">
                                {spinsCategory && spinsCategory.name}
                            </CardTitle>
                            {
                                spinsCategory &&
                                <CardBody>
                                    {
                                        spinsCategory.config.map((_notificationConfig, index) => {
                                            return (
                                                <>
                                                    <Row key={index}>
                                                        <Col md="2">
                                                            <Row>
                                                                <Alert style={{ "padding": 0, "margin": 0 }} color="warning">
                                                                    <Input
                                                                        style={{ "fontSize": 20 }}
                                                                        type="text"
                                                                        value={_notificationConfig.description}
                                                                        onChange={(e) => {
                                                                            var _spinsCategory = { ...spinsCategory }
                                                                            _spinsCategory.config[index].description = e.target.value
                                                                            setSpinsCategory(_spinsCategory)
                                                                        }}
                                                                    />
                                                                </Alert>
                                                            </Row>
                                                            <Alert style={{ marginTop: 10 }} color="default">
                                                                <Row>
                                                                    <Col md="12">
                                                                        <input
                                                                            style={{ "fontSize": 12 }}
                                                                            type="text"
                                                                            placeholder="Test MobileId"
                                                                            value={_notificationConfig.test_mobile_id}
                                                                            onChange={(e) => {
                                                                                var _spinsCategory = { ...spinsCategory }
                                                                                _spinsCategory.config[index].test_mobile_id = e.target.value
                                                                                setSpinsCategory(_spinsCategory)
                                                                            }}
                                                                        /></Col>
                                                                    <Col md="12">
                                                                        <div className="text-center"><Button size="sm" onClick={() => sendTestToMobile(_notificationConfig)}>Send Test</Button></div>
                                                                    </Col>
                                                                </Row>
                                                            </Alert>

                                                        </Col>
                                                        <Col md="2">
                                                            <p style={{ textAlign: "center" }}>Conditions checklist</p>
                                                            <Card>
                                                                <CardBody>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Installed TMH</b>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.conditions.INSTALLED_TMH_APP}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].conditions.INSTALLED_TMH_APP = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row><Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>NOT Installed TMH</b>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.conditions.NOT_INSTALLED_TMH_APP}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].conditions.NOT_INSTALLED_TMH_APP = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Spin wheel</b>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.conditions.SPIN_WHEEL}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].conditions.SPIN_WHEEL = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Wheel timer up</b>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.conditions.WHEEL_TIMER_UP}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].conditions.WHEEL_TIMER_UP = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>User known to be at Roku</b>
                                                                        </Col>
                                                                        <Col style={{ marginTop: 5 }} md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.conditions.ROKU_OPENING}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].conditions.ROKU_OPENING = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>

                                                        <Col md="2">
                                                            <p style={{ textAlign: "center" }}>Action on Roku</p>
                                                            <Card>
                                                                <CardBody>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Open app</b>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.roku_actions.OPEN_APP}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].roku_actions.OPEN_APP = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Open spinner and spin</b>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.roku_actions.OPEN_SPINNER}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].roku_actions.OPEN_SPINNER = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Open content in large player </b>
                                                                        </Col>
                                                                        <Col style={{ marginTop: 5 }} md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.roku_actions.OPEN_CONTENT.action}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].roku_actions.OPEN_CONTENT.action = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    {
                                                                        _notificationConfig.roku_actions.OPEN_CONTENT.action && <Row>
                                                                            <Col style={{ marginLeft: 10 }} md="4">
                                                                                Title:
                                                                            </Col>
                                                                            <Col md="6">
                                                                                <input
                                                                                    style={{ "fontSize": 10, "width": 90 }}
                                                                                    type="text"
                                                                                    value={_notificationConfig.roku_actions.OPEN_CONTENT.title}
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].roku_actions.OPEN_CONTENT.title = e.target.value
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                            <Col style={{ marginLeft: 10 }} md="4">
                                                                                Id:
                                                                            </Col>
                                                                            <Col md="5">
                                                                                <input
                                                                                    style={{ "fontSize": 10, "width": 90 }}
                                                                                    type="text"
                                                                                    value={_notificationConfig.roku_actions.OPEN_CONTENT.id}
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].roku_actions.OPEN_CONTENT.id = e.target.value
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    }

                                                                </CardBody>
                                                            </Card>
                                                        </Col>

                                                        <Col md="2">
                                                            <p style={{ textAlign: "center" }}>Action on Mobile</p>
                                                            <Card>
                                                                <CardBody>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Open app to remote home</b>
                                                                        </Col>
                                                                        <Col style={{ marginTop: 5 }} md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.mobile_actions.OPEN_APP}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].mobile_actions.OPEN_APP = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Open spinner pop over gif over remote page</b>
                                                                        </Col>
                                                                        <Col style={{ marginTop: 5 }} md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.mobile_actions.OPEN_SPINNER}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].mobile_actions.OPEN_SPINNER = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Open to sync page</b>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <Input
                                                                                style={{ width: 20, height: 20 }}
                                                                                type="checkbox"
                                                                                checked={_notificationConfig.mobile_actions.OPEN_SYNC_PAGE}
                                                                                onChange={(e) => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].mobile_actions.OPEN_SYNC_PAGE = e.target.checked
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>

                                                        <Col md="3">
                                                            <p style={{ textAlign: "center" }}>Message</p>
                                                            <Card>
                                                                <CardBody>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="4">
                                                                            <b>Title</b>
                                                                        </Col>
                                                                        <Col style={{ marginTop: 5, padding: 0 }} md="8">
                                                                            <Alert style={{ padding: 0 }} color="default" >
                                                                                <Input
                                                                                    style={{ padding: 5 }}
                                                                                    type="textarea"
                                                                                    value={_notificationConfig.title}
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].title = e.target.value
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                />
                                                                            </Alert>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="4">
                                                                            <b>Body</b>
                                                                        </Col>
                                                                        <Col style={{ marginTop: 5, padding: 0 }} md="8">
                                                                            <Alert style={{ padding: 0 }} color="default" >
                                                                                <Input
                                                                                    style={{ padding: 5 }}
                                                                                    type="textarea"
                                                                                    value={_notificationConfig.message}
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].message = e.target.value
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                />
                                                                            </Alert>
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                        <Col md="1">
                                                            <Row>
                                                                {
                                                                    (spinsCategory?.config.length === index + 1) &&
                                                                    <>
                                                                        <Col md="6" className="text-center">
                                                                            <br />
                                                                            <Button onClick={() => {
                                                                                let _spinsCategory = { ...spinsCategory }
                                                                                _spinsCategory.config.push({ ..._spinsCategory.config[index] })
                                                                                setSpinsCategory(_spinsCategory)
                                                                            }} className="btn-icon btn-simple" color="success" size="sm">
                                                                                <i className="fa-regular fa-clone"></i>
                                                                            </Button>
                                                                        </Col>
                                                                        <Col md="6" className="text-center">
                                                                            <br />
                                                                            <Button onClick={() => {
                                                                                let _spinsCategory = { ...spinsCategory }
                                                                                _spinsCategory.config.pop()
                                                                                setSpinsCategory(_spinsCategory)
                                                                            }} className="btn-icon btn-simple" color="danger" size="sm">
                                                                                <i className="fa-solid fa-square-minus"></i>
                                                                            </Button>
                                                                        </Col>
                                                                    </>
                                                                }
                                                            </Row>

                                                        </Col>

                                                        <Col style={{ marginTop: -45 }} md="4">
                                                            <Card>
                                                                <CardBody>
                                                                    {_notificationConfig.conditions.WHEEL_TIMER_UP &&
                                                                        <Row>
                                                                            <Col style={{ marginTop: 5 }} md="10">
                                                                                <b>Single time (After first spin 24hrs)</b>
                                                                            </Col>
                                                                            <Col md="2">
                                                                                <Input
                                                                                    style={{ width: 20, height: 20 }}
                                                                                    type="checkbox"
                                                                                    checked={_notificationConfig.custom.SINGLE.value}
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].custom.SINGLE.value = e.target.checked
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                    {_notificationConfig.conditions.WHEEL_TIMER_UP &&
                                                                        <Row>
                                                                            <Col style={{ marginTop: 5 }} md="10">
                                                                                <b>Daily (Each {_notificationConfig.custom.DAILY.hours}hrs)</b>
                                                                            </Col>
                                                                            <Col md="2">
                                                                                <Input
                                                                                    style={{ width: 20, height: 20 }}
                                                                                    type="checkbox"
                                                                                    checked={_notificationConfig.custom.DAILY.value}
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].custom.DAILY.value = e.target.checked
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                    {_notificationConfig.conditions.WHEEL_TIMER_UP &&
                                                                        <Row>
                                                                            <Col style={{ marginTop: 5 }} md="10">
                                                                                <b>Weekly</b> {" "}
                                                                                <select
                                                                                    value={_notificationConfig.custom.SPECIFIC_TIME.dayOfWeek}
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].custom.SPECIFIC_TIME.dayOfWeek = e.target.value
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                >
                                                                                    <option value={0}>Sunday</option>
                                                                                    <option value={1}>Monday</option>
                                                                                    <option value={2}>Tuesday</option>
                                                                                    <option value={3}>Wednesday</option>
                                                                                    <option value={4}>Thursday</option>
                                                                                    <option value={5}>Friday</option>
                                                                                    <option value={6}>Saturday</option>
                                                                                </select>
                                                                                {" at "}
                                                                                <input
                                                                                    value={_notificationConfig.custom.SPECIFIC_TIME.hours}
                                                                                    style={{ width: 50 }}
                                                                                    type="number"
                                                                                    placeholder="hours"
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].custom.SPECIFIC_TIME.hours = e.target.value
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                /> {" o'clock "} (ET TimeZone)
                                                                            </Col>
                                                                            <Col md="2">
                                                                                <Input
                                                                                    style={{ width: 20, height: 20 }}
                                                                                    type="checkbox"
                                                                                    checked={_notificationConfig.custom.SPECIFIC_TIME.value}
                                                                                    onChange={(e) => {
                                                                                        var _spinsCategory = { ...spinsCategory }
                                                                                        _spinsCategory.config[index].custom.SPECIFIC_TIME.value = e.target.checked
                                                                                        setSpinsCategory(_spinsCategory)
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                    <Row>
                                                                        <Col md="8" style={{ textAlign: "left", marginTop: 15 }} >
                                                                            <b>Send if criteria met: </b>
                                                                        </Col>
                                                                        <Col style={{ textAlign: "left", marginTop: 10 }} md="2">

                                                                            <Switch
                                                                                onChange={() => {
                                                                                    var _spinsCategory = { ...spinsCategory }
                                                                                    _spinsCategory.config[index].custom.CRITERIA_MET = !_notificationConfig.custom.CRITERIA_MET
                                                                                    setSpinsCategory(_spinsCategory)
                                                                                }}
                                                                                checked={_notificationConfig.custom.CRITERIA_MET} />

                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>

                                                        <Col style={{ marginTop: -45 }} md="3">
                                                            <Card>
                                                                <CardBody>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Image</b>
                                                                            <input
                                                                                style={{ "fontSize": 12, width: "100%" }}
                                                                                type="text"
                                                                                placeholder="Image URL"
                                                                                value={_notificationConfig.image}
                                                                                onChange={(e) => {
                                                                                    var _category = { ...spinsCategory }
                                                                                    _category.config[index].image = e.target.value
                                                                                    setSpinsCategory(_category)
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>

                                                        <Col style={{ marginTop: -15 }} md="4">
                                                            <Card>
                                                                <CardBody>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5, textAlign: "center" }}>
                                                                            <b>{totalQualifyingUsers[_notificationConfig.description] ? totalQualifyingUsers[_notificationConfig.description].total : "<<Update>>"} users in this group</b> <Button size="sm" color="warning" onClick={() => {
                                                                                handleShowTotalQualifyingUsers(_notificationConfig)
                                                                            }}>Show</Button>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <div className="text-center"><Button color="success" onClick={() => {
                                                                                handlePushNotificationToTotalQualifyingUsers(_notificationConfig)
                                                                            }}>Push to qualifying users now</Button></div>
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>

                                                    </Row>
                                                    <Row>
                                                        <Col md="1" />
                                                        <Col md="7" className="mb-4" style={{
                                                            "border": "1px solid"
                                                        }} />
                                                    </Row>
                                                </>)
                                        })
                                    }

                                    <div className="text-center"><Button onClick={() => handleSubmit()}>SAVE</Button></div>
                                </CardBody>
                            }
                        </CardHeader>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>
    )
}